import { ESignatureTermsPage as ESignatureTerms } from "@tellescope/forms";
import { useSearchParams } from "react-router-dom";

export const ESignatureTermsPage = () => {
  const [searchParams] = useSearchParams();

  return <ESignatureTerms companyName={searchParams.get("name") ?? undefined} />;
};
